import { InvoiceFragment } from "__generated__/view/invoices/graphql/invoices.fragments.generated";
import { isAdmin, isCompanyUser, isReadOnly } from "components/utils/Permission";
import { Session } from "ezStore";

export const isInvoiceLocked = (invoice: InvoiceFragment) => {
	const status = invoice?.lastStatusChange?.status;
	return !!(status?.finishedStatus || status?.closedStatus);
};

export const isEditInvoiceAllowed = (invoice: InvoiceFragment, session: Session) =>
	!isInvoiceLocked(invoice) && (isAdmin(session) || isCompanyUser(session)) && !isReadOnly(session);
